import React from 'react';
import PodCastCard from '../../../../../components/podcast/podcast-card';

const ListenLists = ({ allListen }) => {
  return (
    <div className="podcast">
      <div className="cat_watch-list">
        <div className="series">
          <div className="cat_watch-body ">
            <div>
              <div className="wrapper ">
                <div className="cat_watch-list">
                  <div className="cat_watch-row">
                    <div className="cat_watch-body-list">
                      <div className="cat_watch-item">
                        <div className="watch_item-row columns-5 d-flex">
                          {!!allListen.nodes.length &&
                            allListen.nodes.map(
                              (podCast, index) =>
                                !!podCast && <PodCastCard key={index} {...podCast} uid={`/podcast/${podCast.uid}`} />
                            )}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ListenLists;
